import Log from '~/_Utility/Log';

import Async from '~/Async';

class ReView {

    /**
     * @since 2.14.0
     * @method constructor
     * @param string view is the view to refresh
     * @param bool run is a flag indicating immediate run
     */
    constructor(view, run) {
        // Set up variables
        this.view     = view;
        this.selector = view ? '[data-p3-re-view="' + view + '"]' : '';

        // Get our async requestor
        this.async = new Async();

        // Run initialization
        this.init()

        // If we want to run right away, do so
        if (run)
            this.run();
    }

    /**
     * Initialize the class.
     *
     * @since 2.14.0
     * @method init
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('Review initialized for ' + this.view + '.', 'init');
    }

    /**
     * Run the view refresh.
     *
     * @since 2.14.0
     * @method run
     * @return void
     */
    run() {
        // If there are no matching elements, bail out
        if (!this.selector || !$(this.selector).length)
            return;

        // Search for elements
        $(this.selector).each((i, view) => {

            // Run the async post
            this.async.post('re-view', {
                params:  {
                    view: this.view
                },
                success: {
                    callback: (data) => $(view).replaceWith(data.data)
                },
                fail:    {
                    callback: () => new Log('ReView failed', 'error')
                }
            });

        });

    }

}

export default ReView;